import { useCallback, useEffect, useState } from "react";

import { api, type AccountState } from "../lib/api";
import { toUserMessage } from "../lib/errors";

export function useAccountState() {
  const [accountState, setAccountState] = useState<AccountState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await api.getMe();
      setAccountState(next);
    } catch (e) {
      setAccountState(null);
      setError(toUserMessage(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const next = await api.getMe();
        if (!active) return;
        setAccountState(next);
      } catch (e) {
        if (!active) return;
        setAccountState(null);
        setError(toUserMessage(e));
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { accountState, loading, error, reload };
}
